/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDto } from '../../models/admin-dto';

export interface AdminAdminControllerFindAllV1$Params {
}

export function adminAdminControllerFindAllV1(http: HttpClient, rootUrl: string, params?: AdminAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AdminDto>>> {
  const rb = new RequestBuilder(rootUrl, adminAdminControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AdminDto>>;
    })
  );
}

adminAdminControllerFindAllV1.PATH = '/api/v1/admins/admin';
